import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/app.css';
import './styles/master-data.css';
import './styles/handover.css';
import './styles/schedule.css';
import './styles/ui.css';
import './styles/handover-mobile.css';
import './styles/shell.css';
import './styles/home.css';
import './styles/apartment.css';
import './styles/structure.css';
import './styles/defects.css';
import './styles/polish.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
